var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg041Upload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m391 245.928v120a14.989 14.989 0 0 1 -14.985 15h-240.01a15 15 0 0 1 -15-15v-120a15 15 0 0 1 15-15h82.5v30h-67.505v90h210v-89.997h-67.5v-30h82.514a14.989 14.989 0 0 1 14.986 14.997zm-150 72.372h30v-108.549h30.424l-45.424-78.679-45.425 78.679h30.425zm196.018-243.318a255.994 255.994 0 1 1 -181.018-74.982 255.2 255.2 0 0 1 181.018 74.982zm42.982 181.018a224 224 0 1 0 -65.607 158.393 223.3 223.3 0 0 0 65.607-158.393z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg041Upload);
export default __webpack_public_path__ + "static/media/041-upload.ebb14bd748d4813968794ff91f1bc58e.svg";
export { ForwardRef as ReactComponent };